import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import { useState } from 'react';
import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';

const benefits = [
  { icon: 'ri-speed-line', title: 'Daha İyi Performans', desc: 'VergeOS, mevcut sunucularınızda kaynak tüketimini azaltarak daha yüksek VM yoğunluğu ve uygulama hızı sağlar.' },
  { icon: 'ri-shield-check-line', title: 'Daha İyi Korunmuş', desc: 'Fidye yazılımına dayanıklı değişmez anlık görüntüler, global tekilleştirme ve sertleştirilmiş işletim sistemi ile verileriniz koruma altında.' },
  { icon: 'ri-server-line', title: 'Mevcut Sunucularınızı Kullanın', desc: 'Mevcut donanım yatırımınızı koruyun. VergeOS çıplak metal sunucularda çalışır; pahalı donanım değişimi gerekmez.' },
  { icon: 'ri-hard-drive-2-line', title: 'Mevcut Depolamanızı Kullanın', desc: 'FC tabanlı depolama dizileri, NVMe, SAS ve SATA dahil geniş donanım yelpaziyle uyumluluk.' },
];

const nodeTypes = [
  { name: 'Standart Düğümler', desc: 'Intel işlemciler ve SAS flaşı' },
  { name: 'Performans Düğümleri', desc: 'AMD veya Intel işlemciler ve NVMe flaşı' },
  { name: 'Kapasite Düğümleri', desc: 'Düşük uçlu işlemciler ve sabit disk sürücüleri' },
  { name: 'Araştırma Düğümleri', desc: 'Nvidia GPU\'ları ve NVMe flaşı' },
];

const migrationPoints = [
  'Hızlı Öğrenme Eğrisi',
  'Sorunsuz VM Migrasyonu',
  'Mevcut donanımı kullanır',
];

const simplifyPoints = [
  'Uygulama Performansı',
  'Operasyonları Basitleştirme',
  'Sıfır Operasyonel Kod Satırı',
];

const faqList = [
  { q: 'VergeOS nedir?', a: 'VergeOS, sanallaştırmayı, depolamayı ve ağı tek bir veri merkezi işletim sistemine entegre eden yazılım çözümüdür. Mevcut donanımınızda çalışacak şekilde tasarlanmıştır ve sağlam, uygun maliyetli bir alternatif sunar.' },
  { q: 'VergeOS BT maliyetlerini nasıl hemen azaltabilir?', a: 'VergeOS, sanal makineler değil fiziksel sunucular üzerinden lisanslama yaparak çekirdek veya CPU başına lisans maliyetlerini ortadan kaldırır. Bu model, yüksek yoğunluklu ortamlarda önemli maliyet tasarrufu sağlar.' },
  { q: 'Geçiş nasıl sorunsuz hale getirilebilir?', a: 'VergeIO\'nun ioMigrate ile geçiş son derece hızlıdır; Changed Block Tracking (CBT) desteği sayesinde 100 VM\'yi dakikalar içinde taşıyabilirsiniz. Tüm VMware ayarları dönüştürüldüğünden sıfır migrasyon sonrası yapılandırma gerekir.' },
  { q: 'VergeOS performansı nasıl artırır?', a: 'VergeOS, sanallaştırma, depolama ve ağı tek birleşik platformda birleştirerek katmanlar arası veri aktarımını ortadan kaldırır. Global satır içi tekilleştirme ve AI destekli iş yükü yönetimi ile sistem kaynakları optimum biçimde kullanılır.' },
  { q: 'VergeOS ihtiyaçlarıma göre ölçeklenebilir mi?', a: 'Evet. VergeOS 2 düğümden 200 düğüme kadar ölçeklenir. Küçük şubelerden büyük kurumsal veri merkezlerine kadar her ölçekte çalışır. Tek node da ekleyerek yatay olarak büyüyebilirsiniz.' },
  { q: 'VergeOS IT operasyonlarını nasıl basitleştirir?', a: 'VergeOS tek, tutarlı bir yönetim arayüzü sunar. Ayrı depolama, ağ ve sanallaştırma araçlarına gerek yoktur. Bu, BT ekiplerinin bakım yerine stratejik projelere odaklanmasını sağlar.' },
  { q: 'VergeOS\'a geçişin son adımı nedir?', a: 'Son adım, VMware ortamındaki son değişikliklerin ioMigrate ile senkronize edilmesidir. CBT sayesinde bu işlem yalnızca birkaç saniye sürer. Migrasyon tamamlandığında VMware lisansları iptal edilebilir.' },
];

const vmwareFaqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'VergeOS nedir?', acceptedAnswer: { '@type': 'Answer', text: 'VergeOS, sanallaştırmayı, depolamayı ve ağı tek bir veri merkezi işletim sistemine entegre eden yazılım çözümüdür. Mevcut donanımınızda çalışacak şekilde tasarlanmıştır ve sağlam, uygun maliyetli bir alternatif sunar.' } },
    { '@type': 'Question', name: 'VergeOS BT maliyetlerini nasıl hemen azaltabilir?', acceptedAnswer: { '@type': 'Answer', text: 'VergeOS, sanal makineler değil fiziksel sunucular üzerinden lisanslama yaparak çekirdek veya CPU başına lisans maliyetlerini ortadan kaldırır. Bu model, yüksek yoğunluklu ortamlarda önemli maliyet tasarrufu sağlar.' } },
    { '@type': 'Question', name: 'Geçiş nasıl sorunsuz hale getirilebilir?', acceptedAnswer: { '@type': 'Answer', text: "VergeIO'nun ioMigrate ile geçiş son derece hızlıdır; Changed Block Tracking (CBT) desteği sayesinde 100 VM'yi dakikalar içinde taşıyabilirsiniz." } },
    { '@type': 'Question', name: 'VergeOS performansı nasıl artırır?', acceptedAnswer: { '@type': 'Answer', text: 'VergeOS, sanallaştırma, depolama ve ağı tek birleşik platformda birleştirerek katmanlar arası veri aktarımını ortadan kaldırır.' } },
    { '@type': 'Question', name: 'VergeOS ihtiyaçlarıma göre ölçeklenebilir mi?', acceptedAnswer: { '@type': 'Answer', text: 'Evet. VergeOS 2 düğümden 200 düğüme kadar ölçeklenir.' } },
    { '@type': 'Question', name: 'VergeOS IT operasyonlarını nasıl basitleştirir?', acceptedAnswer: { '@type': 'Answer', text: "VergeOS tek, tutarlı bir yönetim arayüzü sunar. Ayrı depolama, ağ ve sanallaştırma araçlarına gerek yoktur." } },
    { '@type': 'Question', name: "VergeOS'a geçişin son adımı nedir?", acceptedAnswer: { '@type': 'Answer', text: "Son adım, VMware ortamındaki son değişikliklerin ioMigrate ile senkronize edilmesidir. CBT sayesinde bu işlem yalnızca birkaç saniye sürer." } },
  ],
};

const vmwareAppJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeOS',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'VMware maliyetlerini %65 düşüren özel bulut işletim sistemi. Mevcut donanımda çalışır, ioMigrate ile sorunsuz geçiş.',
  url: `${SITE_URL}/vmware-alternative`,
};

export default function VMwareAlternativePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [form, setForm] = useState({ email: '', firstName: '', lastName: '', company: '' });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const body = new URLSearchParams();
      Object.entries(form).forEach(([k, v]) => body.append(k, v));
      const res = await fetch('https://readdy.ai/api/form/d6t6ea24of3kuoicmvdg', { method: 'POST', body });
      setStatus(res.ok ? 'success' : 'error');
    } catch { setStatus('error'); }
  };

  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="VMware Alternatifi | VergeOS ile Geçiş ve Maliyet Azaltma"
        description="VergeOS ile VMware maliyetlerini %65 düşürün. Mevcut donanımınızda çalışır, ioMigrate ile sorunsuz geçiş sağlar. En iyi VMware alternatifi karşılaştırması."
        keywords="VMware alternatifi, VMware geçiş, vSphere alternatifi, ESXi alternatifi, VergeOS, VMware lisans maliyeti"
        canonicalPath="/vmware-alternative"
        jsonLd={[vmwareAppJsonLd, vmwareFaqJsonLd]}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">BT Girişimleri</div>
                <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
                  Diğerlerinden <span className="text-[#e8600a]">Daha Fazlası</span> —<br />Uzlaşmasız Alternatif
                </h1>
                <p className="text-gray-300 mb-8 leading-relaxed">VergeOS — Ultraconverged Altyapı. Daha iyi performans, daha güçlü koruma, mevcut donanımınızla.</p>
                <div className="grid grid-cols-2 gap-3 mb-8">
                  {benefits.map(b => (
                    <div key={b.title} className="flex items-center gap-2 text-sm text-gray-300">
                      <i className="ri-check-line text-[#e8600a]"></i>{b.title}
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/5b27a2ce9570cd858dda1149fda7f7c8.jpg" alt="VergeOS Dashboard" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Diğerlerine Karşı Neden VergeOS?</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {benefits.map(b => (
                <div key={b.title} className="bg-[#f8fafc] rounded-lg border border-gray-100 p-6">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-4"><i className={`${b.icon} text-xl`}></i></span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{b.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Hands-on Lab Form */}
        <section className="py-20 bg-[#f8fafc] border-y border-gray-200">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-4">Kontrolü Ele Alın — Uygulamalı Lab'a Erişin</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">VergeIO'yu doğrudan uygulamalı lab üzerinden keşfedin. Lab'lar, teknolojimizle pratik deneyim sunmak üzere tasarlanmış olup satış araması gerektirmez.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Scale */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Eşi Benzeri Görülmemiş Ölçek</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">VergeOS 2 düğümden başlayıp 200'e kadar ölçeklenir. Optimize edilmiş ağ yığını, maksimum esneklik ve platform uzun ömürlülüğü için her yeni düğümün kapasitesini kümülatif olarak ekler.</p>
                <p className="text-gray-600 mb-6 leading-relaxed">BT plancıları herhangi bir kombinasyonu karıştırabilir:</p>
                <div className="grid grid-cols-2 gap-3">
                  {nodeTypes.map(n => (
                    <div key={n.name} className="bg-[#f8fafc] rounded-lg p-4 border border-gray-100">
                      <p className="font-semibold text-[#1e293b] text-xs mb-1">{n.name}</p>
                      <p className="text-xs text-gray-500">{n.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=VergeOS%20global%20resource%20pool%20architecture%20diagram%20showing%20scalable%20nodes%20from%202%20to%20200%20with%20networking%20compute%20and%20storage%20layers%20unified%2C%20dark%20background%20orange%20highlights%20professional%20enterprise%20infrastructure%20visualization%20showing%20horizontal%20scale&width=580&height=420&seq=vmware_alt_scale1&orientation=landscape" alt="VergeOS Ölçek Diyagramı" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* ioMigrate */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=ioMigrate%20VMware%20to%20VergeOS%20migration%20process%20visualization%20showing%20seamless%20VM%20transfer%20with%20Changed%20Block%20Tracking%20technology%2C%20dark%20background%20orange%20data%20flow%20arrows%20from%20VMware%20vSphere%20to%20VergeOS%20unified%20platform%2C%20professional%20enterprise%20migration%20diagram&width=580&height=380&seq=vmware_alt_migrate1&orientation=landscape" alt="ioMigrate ile Kolay Geçiş" className="w-full h-full object-top" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">ioMigrate ile Kolay Geçiş</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">Diğerlerinden VergeOS'a geçiş, ioMigrate ile sorunsuz bir süreçtir. VergeIO, CBT desteği ile gerçek zamanlı kopyalama yapar ve VergeOS'u diğer platformdan DR hedefi olarak kullanmanıza olanak tanır. VMware'i üretim ortamından kaldırır ve maliyetleri %80'e kadar azaltır.</p>
                <ul className="space-y-2 mb-6">
                  {migrationPoints.map(item => (
                    <li key={item} className="flex items-center gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Simplify Operations */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Operasyonları Basitleştirin</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">VergeOS, hiper yöneticiyi, depolama alanı hizmetlerini ve gelişmiş yazılım tanımlı ağ yeteneklerini entegre eden bir veri merkezi işletim sistemidir. Müşterilerimiz günlük operasyonel verimlilikte önemli bir artış bildirmektedir.</p>
                <ul className="space-y-2">
                  {simplifyPoints.map(item => (
                    <li key={item} className="flex items-center gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Çok Kiracılılık — Herkes İçin!</h2>
                <p className="text-gray-600 mb-4 leading-relaxed">Sanal Veri Merkezleri (VDC), temel lisans maliyetine dahildir ve sunulan tüm VDC'ler fidye yazılımı dayanıklılığını artırır, yedekleme dayanıklılığını geliştirir ve gürültülü komşu sorununu ortadan kaldırır.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Reduce Costs */}
        <section className="py-16 bg-[#0f1117]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">Maliyetleri Azaltın</h2>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed max-w-2xl mx-auto">VergeOS, eski HCI yapılandırmalarının sanal hiper yönetici maliyetlerinin yerini alarak geleneksel BT altyapı yığınını tek bir veri merkezi işletim sisteminde birleştirir. Sunucularınızı ve mevcut SAN altyapınızı kullanın.</p>
            <div className="inline-block bg-[#e8600a]/20 border border-[#e8600a]/40 rounded-lg px-6 py-4 mb-8">
              <p className="text-[#e8600a] font-bold text-lg">Fiziksel Sunucu Başına Lisanslama — Çekirdek, RAM ve Kapasiteyi Saymayın!</p>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-20 bg-white border-t border-gray-200">
          <div className="max-w-3xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">En İyi Alternatif SSS</h2>
            <div className="space-y-4">
              {faqList.map((faq, i) => (
                <div key={i} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer">
                    <span className="font-medium text-[#1e293b] text-sm">{faq.q}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-gray-400 shrink-0"><i className={`${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i></span>
                  </button>
                  {openFaq === i && <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">{faq.a}</div>}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
